<template>
  <div class="devices-list-content-root-wrapper">
    <ErrorMessage
      v-if="isDevicesListInvalid"
      slot="devices-list"
      :header="$t('common.error.api')"
      :content="$t('common.error.api_content')"
    />
    <DeviceListLoader v-else-if="isDeviceListLoading" />
    <DevicesListTable
      v-else
      :devicesListState="devicesListState"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import ErrorMessage from '@/components/common/ErrorMessage/ErrorMessage.vue';
import { IDevicesListState } from '@/store/modules/devices/types';
import DeviceListLoader from './components/DeviceListLoader/DeviceListLoader.vue';
import DevicesListTable from './components/DevicesListTable/DevicesListTable.vue';

import './styles/devices-list-content.scss';

@Component({
  components: {
    DevicesListTable,
    DeviceListLoader,
    ErrorMessage
  }
})
export default class DevicesListContent extends Vue {
  @Prop()
  private devicesListState!: IDevicesListState;

  private get isDeviceListLoading(): boolean {
    return this.devicesListState.loading.devicesList;
  }

  private get isDevicesListInvalid() {
    return this.devicesListState.error.devicesList;
  }
}
</script>
